import {TravelCredit} from './travel-credit';

export class TravelCreditBatch {
  public travelCredits: Array<TravelCredit>;
  public totalItems: number;

  constructor(travelCredits, totalItems) {
    this.travelCredits = travelCredits;
    this.totalItems = totalItems;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/travel-credit-batch.ts